import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import manifest from './manifest'
import App from './App.vue'

import { ImagePreloader } from './classes/Preloader.js'
import { TweenLite, Power2 } from 'gsap'

window.app = {}
Vue.use(VueRouter)

// set up router
let router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})

window.app.current = routes[0]
router.afterEach((to, from) => {
  // routes
  window.app.current = to
})

// preload assets before each route transition
router.beforeEach((to, from, next) => {
  const _preloader = new ImagePreloader()
  const _images = manifest[to.name]
  const _slideEasing = Power2.easeOut
  const _slideDuration = 0.5

  let _loader = ''

  const showLoader = () => {
    _loader = document.querySelector('.view-loader__panel')
    TweenLite.fromTo(_loader, _slideDuration, {
      x: -Math.max(_loader.offsetWidth)
    }, {
      x: 0,
      ease: _slideEasing,
      onComplete: preloadImages
    })
  }

  const hideLoader = () => {
    _loader = document.querySelector('.view-loader__panel')
    TweenLite.fromTo(_loader, _slideDuration, {
      x: 0
    }, {
      x: -Math.max(_loader.offsetWidth),
      ease: _slideEasing
    })
    fixControls()
  }

  const preloadImages = () => {
    _preloader.queue(_images)
    _preloader.preload().then(() => {
      // render new screen
      next()
      // hide loader after short delay
      Vue.nextTick(() => setTimeout(() => hideLoader(), 1000))
    })
  }

  if (from.name !== null) {
    // show loader while we preload the assets
    showLoader()
  } else {
    // preload first screen (loader already visible)
    preloadImages()
  }
})

// initialise the app
window.app.vue = new Vue({ // eslint-disable-line no-unused-vars
  router,
  render: h => h(App)
}).$mount('#app')

// disable scrolling on tablets (might need to remove this if we enable swiping between scenes...)
document.ontouchmove = (event) => event.preventDefault()

// enable fastclick
const fastclick = require('fastclick')
fastclick.attach(document.body)

// fix controls on small viewports
let viewportHeight = 0
const fixControls = () => {
  let pos = '20px'
  viewportHeight = window.innerHeight

  if (window.matchMedia('(max-width: 1024px)').matches) {
    pos = '20px'
  } else if (window.matchMedia('(max-width: 1366px) and (max-height: 768px)').matches) {
    pos = (((768 - viewportHeight) / 2) + 20) + 'px'
  } else if (window.matchMedia('(min-width: 1367px) and (max-height: 1080px)').matches) {
    pos = (((1080 - viewportHeight) / 2) + 20) + 'px'
  }

  let viewControls = document.querySelector('.view-controls__wrapper')
  viewControls.style.bottom = pos
}
window.addEventListener('resize', () => fixControls())
fixControls()

// fix controls on small viewports
const logoPosition = () => {
  let pos = '0'

  if (window.matchMedia('(max-width: 1024px)').matches) {
    pos = '0'
  } else if (window.matchMedia('(max-width: 1366px) and (max-height: 768px)').matches) {
    pos = ((768 - viewportHeight) / 2) + 'px'
  } else if (window.matchMedia('(min-width: 1367px) and (max-height: 1080px)').matches) {
    pos = ((1080 - viewportHeight) / 2) + 'px'
  }

  let logoBlock = document.querySelector('.app-logo')
  logoBlock.style.top = pos
}
window.addEventListener('resize', () => logoPosition())
logoPosition()



// WEBPACK FOOTER //
// ./src/main.js